
<div>
  <b-modal
    :id="modalId"
    v-model="isVisible"
    modal-class="custom-modal-width"
    body-class="compteClair"
    header-class="compteClair"
    footer-class="compteClair"
    centered
    no-fade
    no-close-on-backdrop
    no-close-on-esc
    @hidden="handleClose"
  >
    <!-- Header personnalisé -->
    <template #modal-header="{ close }">
      <div class="w-100 d-flex justify-content-between align-items-center">
        <h2
          class="titre mb-0 pt-1"
          :class="{
            'service-unavailable-title': mode === 'service-unavailable',
            h4: mode !== 'service-unavailable',
          }"
        >
          {{ modalTitle }}
        </h2>
        <button type="button" class="close" aria-label="Fermer" @click="close()">
          <svg-icon icon-name="icone-fermer-x" className="icone-fermer-modale" />
        </button>
      </div>
    </template>

    <!-- Contenu selon le mode -->
    <template v-if="mode === 'validation'">
      <!-- Boutons radio pour choisir l'adresse -->
      <div class="address-choice-container">
        <!-- Adresse suggérée -->
        <div class="address-option">
          <label class="address-label">{{ suggestedAddressTitle }}</label>
          <BoutonRadioPersonnalise
            id="suggestedAddressOption"
            :model-value="selectedAddressType"
            value="suggested"
            name="addressChoice"
            :is-suggested="true"
            @update:modelValue="handleAddressTypeChange"
          >
            <template #content>
              <!-- Adresse suggérée unique -->
              <div v-if="suggestedAddress" class="mb-0 address-text address-multiline">
                <span class="address-text address-multiline">
                  {{ formatAddressWithApartment(suggestedAddress) }}
                </span>
              </div>

              <!-- Aucune adresse suggérée -->
              <div v-else class="mb-0 address-text text-muted font-italic">
                {{ labels.noSuggestedAddress || 'Aucune adresse suggérée' }}
              </div>
            </template>
          </BoutonRadioPersonnalise>
        </div>

        <!-- Adresse saisie -->
        <div class="address-option">
          <label class="address-label">{{ labels.enteredAddress || 'Adresse saisie' }}</label>
          <BoutonRadioPersonnalise
            id="enteredAddressOption"
            :model-value="selectedAddressType"
            value="entered"
            name="addressChoice"
            @update:modelValue="handleAddressTypeChange"
          >
            <template #content>
              <span class="mb-0 address-text address-multiline">
                {{ formatAddressWithApartment(enteredAddress) }}
              </span>
            </template>
          </BoutonRadioPersonnalise>
        </div>
      </div>
    </template>
    <!-- Mode Not Validated (adresse non vérifiée) -->
    <template v-else-if="mode === 'not-validated'">
      <!-- Message d'explication -->
      <p class="mb-3">
        {{
          labels.notValidatedInfo || "Assurez-vous que votre adresse ne contient pas d'erreur."
        }}
      </p>

      <!-- Adresse saisie en gras -->
      <span class="mb-3 address-text address-multiline">
        {{ formatAddressWithApartment(enteredAddress) }}
      </span>
    </template>

    <!-- Mode Service indisponible -->
    <template v-else-if="mode === 'service-unavailable'">
      <!-- Message d'explication -->
      <p class="mb-3">
        {{ labels.serviceUnavailableMessage || 'Vérifiez-la avant de continuer.' }}
      </p>

      <!-- Adresse saisie en gras -->
      <p class="mb-3 address-text">
        <span class="address-multiline">
          {{ formatAddressWithApartment(enteredAddress) }}
        </span>
      </p>
    </template>

    <!-- Footer avec boutons -->
    <template #modal-footer>
      <div
        class="w-100 d-flex flex-column flex-sm-row"
        :class="{
          'justify-content-center': mode !== 'service-unavailable',
          'justify-content-between': mode === 'service-unavailable',
        }"
        style="gap: 1rem"
      >
        <!-- Mode validation -->
        <template v-if="mode === 'validation'">
          <b-button
            variant="secondaire"
            size="md"
            class="mb-0 order-1 order-sm-1"
            @click="handleModifyAddress"
          >
            {{ labels.btnModifyAddress || "Modifier l'adresse" }}
          </b-button>
          <b-button
            variant="primaire"
            size="md"
            class="mb-0 order-2 order-sm-2"
            @click="handleContinueWithoutValidation"
          >
            {{ labels.btnContinueAndSave || 'Continuer avec cette adresse' }}
          </b-button>
        </template>

        <!-- Mode not-validated -->
        <template v-else-if="mode === 'not-validated'">
          <b-button
            variant="primaire"
            size="md"
            class="mb-0 order-1 order-sm-1"
            @click="handleModifyAddress"
          >
            {{ labels.btnModifyAddress || "Modifier l'adresse" }}
          </b-button>
          <b-button
            variant="secondaire"
            size="md"
            class="mb-0 order-2 order-sm-2"
            @click="handleContinueWithoutValidation"
          >
            {{ labels.btnContinueAndSave || 'Continuer avec cette adresse' }}
          </b-button>
        </template>

        <!-- Mode service indisponible -->
        <template v-else-if="mode === 'service-unavailable'">
          <b-button
            variant="secondaire"
            size="md"
            class="mb-0 order-1 order-sm-1"
            @click="handleModifyAddress"
          >
            {{ labels.btnModifyAddress || "Modifier l'adresse" }}
          </b-button>
          <b-button
            variant="primaire"
            size="md"
            class="mb-0 order-2 order-sm-2"
            @click="handleContinueWithoutValidation"
          >
            {{ labels.btnContinueAndSave || 'Continuer avec cette adresse' }}
          </b-button>
        </template>
      </div>
    </template>
  </b-modal>
</div>
